import { render, staticRenderFns } from "./StatementResidentPagination.vue?vue&type=template&id=b4e8d19c&scoped=true&"
import script from "./StatementResidentPagination.vue?vue&type=script&lang=ts&"
export * from "./StatementResidentPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e8d19c",
  null
  
)

export default component.exports